/**
 * Sports Configuration
 * Master list of sports, route mappings, and constants for the new API
 */

export const GAMES = [
  { name: 'Football', route: 'football', sid: 1 },
  { name: 'Tennis', route: 'tennis', sid: 2 },
  { name: 'Mixed Martial Arts', route: 'mma', sid: 3 },
  { name: 'Cricket', route: 'cricket', sid: 4 },
  { name: 'Table Tennis', route: 'table-tennis', sid: 8 },
  { name: 'Basketball', route: 'basketball', sid: 15 },
  { name: 'Ice Hockey', route: 'ice-hockey', sid: 19 },
  { name: 'Baseball', route: 'baseball', sid: 53 },
  { name: 'Rugby Union', route: 'rugby-union', sid: 54 },
];

// Route string → SID mapping (built from GAMES)
export const ROUTE_TO_SID = Object.fromEntries(
  GAMES.map((g) => [g.route, g.sid])
);

// SID → sport name mapping (built from GAMES)
export const SID_TO_NAME = Object.fromEntries(
  GAMES.map((g) => [g.sid, g.name])
);

// SID → game object mapping
export const SID_TO_GAME = Object.fromEntries(
  GAMES.map((g) => [g.sid, g])
);

// Popular sport SIDs — Cricket, Football, Tennis
export const POPULAR_SPORT_SIDS = [4, 1, 2];
